module.exports = __webpack_public_path__ + "static/Nida_Sahar-1625e5233bd57faa8f3da50c179bfab2.jpg";